import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "step-title-container"
}
const _hoisted_2 = {
  key: 1,
  class: "inclusions-selector"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "inclusions-wrapper" }
const _hoisted_5 = {
  key: 0,
  class: "divider"
}
const _hoisted_6 = { class: "inclusions-grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!$setup.isDesktop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode($setup["BuilderEstimatorStepTitle"], { title: `Inclusions` })
        ]))
      : _createCommentVNode("", true),
    (!$setup.isDesktop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.inclusionTypes, (type) => {
            return (_openBlock(), _createElementBlock("button", {
              key: type,
              class: _normalizeClass({ selected: $setup.selectedType === type, unselected: $setup.selectedType !== type }),
              onClick: ($event: any) => ($setup.setInclusionType(type))
            }, _toDisplayString(type), 11, _hoisted_3))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (!$setup.isDesktop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.packages, (pack) => {
          return (_openBlock(), _createBlock($setup["InclusionPackCard"], {
            key: pack.type,
            pack: pack,
            "is-selected": $setup.selectedPackage?.inclusionId.type === pack.inclusionId.type,
            "has-selected": !!$setup.selectedPackage,
            "expanded-sections": $setup.expandedSections,
            onOnSelect: _cache[0] || (_cache[0] = ($event: any) => ($setup.onSelectInclusionPack($event))),
            onOnToggleSection: $setup.toggleSection
          }, null, 8, ["pack", "is-selected", "has-selected", "expanded-sections"]))
        }), 128))
      ])
    ])
  ], 64))
}